import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_TRANSACTION_NETWORK_DEF,
} from "./actionTypes"

import {
    getTransactionNetworkDefListSuccess,
    transactionNetworkDefApiError
} from "./actions"

import {
    GetAllTransactionNetworkDef,
} from "../../helpers/backend_helper/backend_helper"

function* onGetTransactionNetworkDefList() {
  try {
    const response = yield call(GetAllTransactionNetworkDef)
    yield put(getTransactionNetworkDefListSuccess(response))
  } catch (error) {
    yield put(transactionNetworkDefApiError(error))
  }
}

function* transactionNetworkDefSaga() {
    yield takeEvery(GET_TRANSACTION_NETWORK_DEF,onGetTransactionNetworkDefList)
}

export default transactionNetworkDefSaga